import DatePickerComponent from "components/DatePickerComponent";
import React from "react";


export default class StepDatePicker extends React.Component{
    render(){
        return <DatePickerComponent
            className={""}
            {...this.props}
            />
    }
}